import { Avatar } from '@/components/Avatar'
import { User } from '@/types'

import s from './AvatarGroup.module.css'

type Props = {
  users: User[]
}

export const AvatarGroup = ({ users }: Props) => {
  return (
    <div className={s.wrapper}>
      {users.slice(0, 3).map((user) => (
        <Avatar key={user.id} src={user.image} name={user.name} size="md" />
      ))}
      {users.length > 3 && (
        <div className={s.remaining}>{users.length - 3}</div>
      )}
    </div>
  )
}
